<script lang="ts">
  import TableFormCell from "@kontextwerk/web-sdk/ui/layout/TableFormCell.svelte"
  import InboxRowSelectInput from "../../../../_shared/_modules/inbox-row-select-input"

  type ActionSelectOption = {
    value: string
    label: string
    disabled?: boolean
    tooltip?: string | null
    tooltipContent?: string | null
    description?: string | null
    dataTestid?: string
  }

  let {
    value = $bindable<string | null>(""),
    options = [],
    disabled = false,
    ariaLabel = "Aktion auswählen",
    placeholder = "Aktion",
    onChange,
  }: {
    value: string | null
    options?: ActionSelectOption[]
    disabled?: boolean
    ariaLabel?: string
    placeholder?: string
    onChange: (value: string) => void
  } = $props()
</script>

<div class="inbox-action-select-cell" aria-label={ariaLabel}>
  <TableFormCell style="width: 100%; min-width: 0; max-width: 100%;">
    <InboxRowSelectInput
      {placeholder}
      {ariaLabel}
      bind:value
      {options}
      {disabled}
      classList="inbox-action-select-control"
      selectStyle="width: 100%; min-width: 0;"
      onChange={(next) => onChange(next)}
    />
  </TableFormCell>
</div>

<style>
  .inbox-action-select-cell {
    align-items: center;
    display: flex;
    max-width: 100%;
    min-width: 0;
    width: 100%;
  }
</style>
